/* eslint-disable jsx-a11y/alt-text */
function ImageModal(imageUrl: string) {
  return (
    <div className="w-full">
      <img className="w-full object-cover" src={imageUrl} />
    </div>
  );
}

export default ImageModal;
